<template>
  <div>
    <gallery :images="images" :index="index" @close="index = null"></gallery>
    <div class="rowc">
      <div class="columnc">
        <div
          class="imgc"
          :style="{backgroundColor:'rgb('+image.color+')',width:'100%',height:selwidth*(image.height/image.width)+'px'}"
          v-for="(image, imageIndex) in images"
          :key="imageIndex" 
          v-if="imageIndex%2==0 && image.disabled==0"
          @click="index = imageIndex"
        >
          <blurimg :alt="image.title" :src="image.href" :placeholder="image.href"/>        
        </div>
      </div>
      <div class="columnc">
        <div
          class="imgc"
          :style="{backgroundColor:'rgb('+image.color+')',width:'100%',height:selwidth*(image.height/image.width)+'px'}"
          v-for="(image, imageIndex) in images"
          :key="imageIndex"
          v-if="imageIndex%2!=0 && image.disabled==0"
          @click="index = imageIndex"
        >
          <blurimg :alt="image.title" :src="image.href"/>        
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
export default {
  name: 'Nude',

  data () {
    return {
      selwidth: 0,
      images: [],
      index: null
    }
  },
  methods: {
    getImages: function() {
      var that=this;
      axios.get("http://denys.photos/admin/api.php?action=getPhotos&value=2")
      .then(function(response){
        that.selwidth=that.$el.lastChild.lastChild.clientWidth;
        that.images=response.data.images;
      });
    }
  },

  created: function(){
    this.getImages();
  }

}
</script>

<style lang="scss" scoped>
@import '../assets/css/image-grid.css'
</style>




// WEBPACK FOOTER //
// src/pages/nude.vue